import axios from 'axios'
import { useApi } from './api'

export const apiCriticasIntrajornada = () => {
  const { api } = useApi()

  const obter = async (params) => {
    const { data } = await api.post('/relatorios/critica-intra-jornada', params)
    return data
  }

  const post = async (params) => {
    const { data } = await api.post('/relatorios/historico-critica-intra-jornada', params)

    return data
  }

  return {
    obter,
    post
  }
}
